import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { environment } from '../../../environments/environment';
import { SendEmailInterface } from './interfaces/sendmail_response.interface';

type CallbackFunction = (response: SendEmailInterface | null, error: SendEmailInterface | null) => void;

@Injectable({
  providedIn: 'root'
})
export class MailService {
  API_URL: string = environment.apiURL;

  private http = inject(HttpClient);

  sendEmail(name: string, email: string, phone: string, description: string, callback: CallbackFunction) {
    const body = {
      name,
      email,
      phone,
      description
    };

    this.http.post<SendEmailInterface>(`${this.API_URL}/mail`, body, { observe: 'response' })
      .subscribe(
        (response) => {
          const serviceResponse: SendEmailInterface = { message: response.body?.message };
          callback(serviceResponse, null);
        },
        (error) => {
          const serviceError: SendEmailInterface = { message: error.error.message };
          callback(null, serviceError);
        }
      );
  }
}
